import {PaidMediaExportFields} from '#lit/types/journey/paid_media_export.js';
import {CampaignTriggersExportActions} from '#lit/types/journeys.js';

export const JOURNEY_LAYER_ROOT_KEY = '__JOURNEY_ROOT__';
export const journeyRequestCache = new Map<string, Record<string, unknown>>();
export const JOURNEYS_BASE_URL = '/v2/journeys';
export const BASE_REQUIRED_FIELDS = [PaidMediaExportFields.EXPORT_NAME];
export const EMAIL_REQUIRED_FIELDS = [PaidMediaExportFields.MATCH_FIELDS];
export const ADS_REQUIRED_FIELDS = [PaidMediaExportFields.MATCH_FIELDS];
export const DW_REQUIRED_FIELDS = [
  PaidMediaExportFields.TABLE_NAME,
  PaidMediaExportFields.MATCH_FIELDS,
];

export const CAMPAIGN_TRIGGERS_REQUIRED_FIELDS = [
  PaidMediaExportFields.EXPORT_ACTION,
];

export const CAMPAIGN_TRIGGERS_SEND_EMAIL_REQUIRED_FIELDS = [
  PaidMediaExportFields.TEMPLATE_ID,
];

export const CAMPAIGN_TRIGGERS_SEND_EMAIL_CHOOSE_SENDER_REQUIRED_FIELDS = [
  PaidMediaExportFields.SENDER_EMAIL,
];

export const SFMC_ADD_TO_EXISTING_DATA_EXTENSION_REQUIRED_FIELDS = [
  PaidMediaExportFields.EXISTING_SFMC_DATA_EXTENSION,
];

export const SENDABLE_EXPORT_ACTIONS = [
  CampaignTriggersExportActions.SEND_EMAIL,
  CampaignTriggersExportActions.SEND_SMS,
];
